import DateFormat from 'constants/date_format';

export function formatDate(date) {
  if (date) {
    date = moment(
      moment(date).format(DateFormat.fixed.ISO8601_LOCAL) + 'Z',
    ).format(DateFormat.LONG_AT_TIME);
  } else {
    date = moment(moment().format(DateFormat.fixed.ISO8601_LOCAL) + 'Z').format(
      DateFormat.LONG_AT_TIME,
    );
  }
  return date;
}

export function formatDateUTC(date) {
  if (date) {
    date = moment(
      moment(date).utc().format(DateFormat.fixed.ISO8601_LOCAL) + 'Z',
    ).format(DateFormat.LONG_AT_TIME);
  } else {
    date = moment(
      moment().utc().format(DateFormat.fixed.ISO8601_LOCAL) + 'Z',
    ).format(DateFormat.LONG_AT_TIME);
  }
  return date;
}
